export * from "./briefs";

export const OPINION_COUNT_LIMIT = 20;
